module.exports = __webpack_public_path__ + "static/media/best-colleges.90c91560.jpg";